const _temp0 = require("../components/CommandWidgets.jsx");
const _temp1 = require("../components/FileContent.jsx");
const _temp2 = require("../components/NctrlValueWidgets.jsx");

const _temp3 = require("./Dashboard.jsx");
const _temp4 = require("./Home.jsx");
const _temp5 = require("./Registers.jsx");
const _temp6 = require("./SystemInformation.jsx");
const _temp7 = require("./Wifi.jsx");

module.exports = {
  "components":   {
    "CommandWidgets": _temp0,
    "FileContent": _temp1,
    "NctrlValueWidgets": _temp2
  },
  "routes":   {
    "Dashboard": _temp3,
    "Home": _temp4,
    "Registers": _temp5,
    "SystemInformation": _temp6,
    "Wifi": _temp7
  }
}